// One place that every call to the server passes through (it wraps window.fetch):
// - adds the login token when a screen didn't,
// - logs the user out when the session is over (HTTP 401, or 403 with { logout: true }),
// - on a server error (HTTP 5xx) or no connection, shows a message and stops the loading spinner.
import { toast } from 'react-toastify';

const originalFetch = window.fetch.bind(window);

function isApi(target) {
    return typeof target === 'string' && target.includes('/api/');
}

function storedToken() {
    try {
        const user = JSON.parse(localStorage.getItem('users') || 'null');
        return user && user.token;
    } catch (e) {
        return null;
    }
}

// Screens listen for this to hide their loading spinner (see UserContext).
function reportFailure(message) {
    window.dispatchEvent(new CustomEvent('api-error', { detail: { message } }));
    toast.error(message, { toastId: 'api-error' });
}

window.fetch = async function guardedFetch(input, init = {}) {
    const target = typeof input === 'string' ? input : (input && input.url) || '';

    if (isApi(target) && typeof input === 'string') {
        const headers = new Headers(init.headers || {});
        const token = storedToken();
        if (token && !headers.has('Authorization')) headers.set('Authorization', token);
        init = { ...init, headers };
    }

    let response;
    try {
        response = await originalFetch(input, init);
    } catch (err) {
        if (isApi(target)) reportFailure('Could not reach the server. Check your internet connection and try again.');
        throw err;
    }

    if (!isApi(target)) return response;

    if (response.status === 401 || response.status === 403) {
        let body = {};
        try { body = await response.clone().json(); } catch (e) { /* not JSON */ }
        if (response.status === 401 || body.logout) {
            try { sessionStorage.setItem('login_message', body.message || 'Please log in again.'); } catch (e) { }
            localStorage.setItem('users', 'null');
            if (!window.location.pathname.startsWith('/login')) {
                window.location = window.location.origin + '/login';
            }
        }
    } else if (response.status >= 500) {
        let body = {};
        try { body = await response.clone().json(); } catch (e) { /* not JSON */ }
        reportFailure(body.message || 'Oops something went wrong! Nothing was saved.');
    }

    return response;
};
